// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"538":"0466eb8a75adb7d5","854":"f9959ff3d241de8b","948":"55562fe65f495ea2","973":"aada306c31a7725c","983":"c3214ba765c2f312"}[chunkId] + ".js";
};